import React from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import {Helmet} from 'react-helmet';
import './layout.css';
export default function Layout({ children, id, sourcePath}) {
   const {site: { buildTime, siteMetadata: { githubRepo, siteUrl }}} = useStaticQuery(graphql`
        query {
            site {
                buildTime
                siteMetadata {
                    githubRepo
                    siteUrl
                }
            }
        }
    `);
  return (
    <div id={id}>
      <Helmet>
        <meta content="text/html; charset=UTF-8" httpEquiv="Content-Type" />
        <meta charset="utf-8" />
        <meta content="width=device-width, initial-scale=1" name="viewport" />
        <meta content="ie=edge" httpEquiv="x-ua-compatible" />
        <link href="https://www.jenkins.io/favicon.ico" rel="shortcut icon" type="image/x-icon" />
        <link href="https://www.jenkins.io/apple-touch-icon.png" rel="apple-touch-icon" sizes="180x180" />
        <link href="https://www.jenkins.io/favicon-32x32.png" rel="icon" sizes="32x32" type="image/png" />
        <link href="https://www.jenkins.io/favicon-16x16.png" rel="icon" sizes="16x16" type="image/png" />
        <link href="/site.webmanifest" rel="manifest" />
        <link color="#5bbad5" href="https://www.jenkins.io/safari-pinned-tab.svg" rel="mask-icon" />
        <meta content="#2b5797" name="msapplication-TileColor" />
        <meta content="#ffffff" name="theme-color" />
        <meta content="summary_large_image" name="twitter:card" />
        <meta content="@JenkinsCI" name="twitter:site" />
        <meta content="@JenkinsCI" name="twitter:creator" />
        <meta content="article" property="og:type" />
        <meta content="https://www.jenkins.io/template/" property="og:url" />
        <style >
          {`html { min-height:100%; position: relative; }`}
        </style>
      </Helmet>
<jio-navbar class="fixed-nav" theme="auto" property="https://plugins.jenkins.io/"></jio-navbar>
      <div id="grid-box">
        {children}
      </div>
<jio-footer githubRepo={sourcePath ? githubRepo : ''} property="https://plugins.jenkins.io/" sourcePath={sourcePath} githubBranch="main" reportAProblemTemplate="4-bug.yml"></jio-footer>
      <Helmet>
        <script src="https://www.jenkins.io/assets/bower/jquery/jquery.min.js" />
        <script src="https://www.jenkins.io/js/copy-to-clipboard.js" />
        <script src="https://www.jenkins.io/assets/bower/anchor-js/anchor.min.js" />
        <script src="https://www.jenkins.io/assets/bower/@popperjs/core/umd/popper.min.js" />
        <script src="https://www.jenkins.io/assets/bower/bootstrap/js/bootstrap.min.js" />
        <script src="https://cdn.jsdelivr.net/npm/lit@3.2.1/polyfill-support.js" />
        <script src="https://cdn.jsdelivr.net/npm/@webcomponents/webcomponentsjs@2.8.0/webcomponents-loader.js" />
        <script data="ionicons" defer src="https://cdnjs.cloudflare.com/ajax/libs/ionicons/7.4.0/ionicons/ionicons.esm.js" type="module" />
        <script data="ionicons" defer noModule src="https://cdnjs.cloudflare.com/ajax/libs/ionicons/7.4.0/ionicons/ionicons.js" />
        <script defer src="https://cdn.jsdelivr.net/npm/@jenkinsci/jenkins-io-components/+esm" type="module" />
        <script defer noModule src="https://cdn.jsdelivr.net/npm/@jenkinsci/jenkins-io-components/" />
        <script  dangerouslySetInnerHTML={{__html: ["\n  $(function(){\n    var $body = $(document.body);\n    $body.on(\"keydown\", function(){\n      $body.removeClass(\"no-outline\");\n    })\n    const updateTheme = () => {\n        const dark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;\n        document.documentElement.dataset.theme = dark ? \"dark\" : \"\";\n    }\n    updateTheme();\n    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateTheme);\n  })\n"]}} />
      </Helmet>
    </div>
  );
}